/**
 * AccountProfileDropdown.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DropdownMenuItems from './DropdownMenuItems';

import * as SecurityHelper from '../../../helpers/securityHelper';
import * as Icons from '../../sharedComponents/icons/Icons';

import { ACCOUNT_PROPS } from '../constants';

export default class AccountProfileDropdown extends React.PureComponent {
    static propTypes = {
        account: ACCOUNT_PROPS,
        isGuest: PropTypes.bool,
        signOut: PropTypes.func
    };

    static defaultProps = {
        account: {},
        signOut: () => { }
    };

    constructor(props) {
        super(props);

        this.state = {
            profilePictureURL: '',
            showDropdown: false
        };

        this.keyboardBindings = [];
    }

    componentDidMount() {
        this.getProfilePicture();
    }

    componentDidUpdate(prevProps) {
        const {
            account: { account: { profile_picture_id: profilePictureId } }
        } = this.props;

        const {
            account: { account: { profile_picture_id: prevProfilePictureId } }
        } = prevProps;

        if (profilePictureId !== prevProfilePictureId) {
            this.getProfilePicture();
        }
    }

    getProfilePicture = async () => {
        const {
            account: { account: { profile_picture_id: id } }
        } = this.props;

        if (!id) {
            return;
        }

        try {
            const url = `${process.env.API}/media/external/${id}`;
            const options = {
                headers: { Authorization: SecurityHelper.getAuthHeader() }
            };

            const response = await axios.get(url, options);

            this.setState({
                profilePictureURL: response.data.url
            });
        }
        catch {
            this.setState({
                profilePictureURL: ''
            });
        }
    }

    toggleDropdown = () => {
        const { showDropdown } = this.state;
        this.setState({
            showDropdown: !showDropdown
        });
    }

    render() {
        let fullName = "";

        if (this.props.isGuest) {
            fullName = "Guest"
        }
        else {
            const firstName = this.props.account.account.first_name;
            const lastInitial = this.props.account.account.last_name[0];
            fullName = firstName;
            if (lastInitial.length > 0) {
                fullName = `${firstName} ${lastInitial}.`;
            }
        }

        // Set border and icon based on state's open/closed value
        let showDropdown = 'hide';
        let selectBorder = '';

        if (this.state.showDropdown) {
            showDropdown = '';
            selectBorder = 'open';
        }

        let commercialAccountIcon = "";
        if (this.props.account.account.is_commercial_account || this.props.isGuest) {
            commercialAccountIcon = 'commerical-account-active';
        }

        let accountImage = (
            <div className={`rec-account-default-icon ${commercialAccountIcon}`}>
                <Icons.IconAccountCircle />
            </div>
        );
        if (this.state.profilePictureURL) {
            accountImage = <img src={this.state.profilePictureURL} alt={`Profile of ${fullName}`} />;
        }

        let arrowIcon = null;
        if (!this.props.isGuest) {
            arrowIcon = (
                <span className="rec-select-icon">
                    <Icons.IconArrowDown />
                </span>
            )
        }

        return (
            <div className="rec-select-holder nav-profile-dropdown">
                <button
                    className={`rec-select ${selectBorder}`}
                    title="My Account"
                    aria-label="My Account"
                    onClick={this.toggleDropdown}>
                    <span className="rec-select-profile-photo">
                        {accountImage}
                    </span>
                    <span className="rec-select-label">
                        {fullName}
                    </span>
                    {arrowIcon}
                </button>
                <div className={`rec-select-options ${showDropdown}`}>
                    <DropdownMenuItems
                        isGuest={this.props.isGuest}
                        commercialAccount={this.props.account.account.is_commercial_account}
                        signOut={this.props.signOut} />
                </div>
            </div>
        );
    }
}